import { getApiUrl } from '../utils/apiUrl';

const API_BASE_URL = getApiUrl();

export const getAllInquiries = async (token) => {
  const response = await fetch(`${API_BASE_URL}/inquiries`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch inquiries');
  }
  
  return response.json();
};

export const getInquiryById = async (id, token) => {
  const response = await fetch(`${API_BASE_URL}/inquiries/${id}`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch inquiry');
  }
  
  return response.json();
};

export const getInquiriesByStatus = async (status, token) => {
  const response = await fetch(`${API_BASE_URL}/inquiries/status/${status}`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch inquiries');
  }
  
  return response.json();
};

export const createInquiry = async (inquiryData, token) => {
  const response = await fetch(`${API_BASE_URL}/inquiries`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(inquiryData)
  });
  
  if (!response.ok) {
    throw new Error('Failed to create inquiry');
  }
  
  return response.json();
};

export const updateInquiry = async (id, inquiryData, token) => {
  const response = await fetch(`${API_BASE_URL}/inquiries/${id}`, {
    method: 'PUT',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(inquiryData)
  });
  
  if (!response.ok) {
    throw new Error('Failed to update inquiry');
  }
  
  return response.json();
};

export const updateInquiryStatus = async (id, status, token) => {
  const response = await fetch(`${API_BASE_URL}/inquiries/${id}/status`, {
    method: 'PATCH',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ status })
  });
  
  if (!response.ok) {
    throw new Error('Failed to update inquiry status');
  }
  
  return response.json();
};

export const updateInquiryMemo = async (id, memo, token) => {
  const response = await fetch(`${API_BASE_URL}/inquiries/${id}/memo`, {
    method: 'PATCH',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ memo })
  });
  
  if (!response.ok) {
    throw new Error('Failed to update inquiry memo');
  }
  
  return response.json();
};

export const deleteInquiry = async (id, token) => {
  const response = await fetch(`${API_BASE_URL}/inquiries/${id}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to delete inquiry');
  }
  
  return response.json();
};

export const getInquiryDocuments = async (inquiryId, token) => {
  const response = await fetch(`${API_BASE_URL}/inquiries/${inquiryId}/documents`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch documents');
  }
  
  return response.json();
};

export const uploadDocument = async (inquiryId, file, token) => {
  const formData = new FormData();
  formData.append('document', file);
  
  const response = await fetch(`${API_BASE_URL}/inquiries/${inquiryId}/documents`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`
    },
    body: formData
  });
  
  if (!response.ok) {
    throw new Error('Failed to upload document');
  }
  
  return response.json();
};

export const deleteDocument = async (inquiryId, documentId, token) => {
  const response = await fetch(`${API_BASE_URL}/inquiries/${inquiryId}/documents/${documentId}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to delete document');
  }
  
  return response.json();
};

export const downloadDocument = async (inquiryId, documentId, token) => {
  const API_BASE_URL = getApiUrl();
  window.open(`${API_BASE_URL}/inquiries/${inquiryId}/documents/${documentId}/download?token=${token}`, '_blank');
};

export const getStatusLog = async (inquiryId, token) => {
  const API_BASE_URL = getApiUrl();
  const response = await fetch(`${API_BASE_URL}/inquiries/${inquiryId}/status-log`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch status log');
  }
  
  return await response.json();
};

export const getUsersWhoCanCreateWorkOrders = async (token) => {
  const response = await fetch(`${API_BASE_URL}/inquiries/users/can-create-work-orders`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch users');
  }
  
  return response.json();
};

export const getAssignedInquiriesCount = async (token) => {
  const response = await fetch(`${API_BASE_URL}/inquiries/assigned/count`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch assigned count');
  }
  
  return response.json();
};
